import { GetSelfAppCategoryAveragesSummaryQuery } from '../../../queries/app-category-metrics/get-self-app-category-averages-summary.query';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetSelfAppCategoryAveragesSummaryRequestDto } from '../../../dtos/team-metrics/category/get-self-app-category-averages-summary.request.dto';
import { GetSelfAppCategoryAveragesSummaryResponseDto } from '../../../dtos/team-metrics/category/get-self-app-category-averages-summary.response.dto';
import { SelfAppCategoryAveragesSummaryEntityMapper } from '../../../../../src/infrastructure/mappers/team-metrics/category/self-app-category-average-summary.mapper';

export class GetSelfAppCategoryAveragesSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly appQuery: GetSelfAppCategoryAveragesSummaryQuery,
    protected readonly selfAppAverageSummaryEntityMapper: SelfAppCategoryAveragesSummaryEntityMapper
  ) {}

  async get(
    props: GetSelfAppCategoryAveragesSummaryRequestDto
  ): Promise<GetSelfAppCategoryAveragesSummaryResponseDto> {
    try {
      const apps = await this.appQuery.execute(props);
      return this.selfAppAverageSummaryEntityMapper.toResponse(apps);
    } catch (error) {
      throw new Error(
        `GetSelfAppCategoryAveragesSummaryController.get encountered an error ${error}`
      );
    }
  }
}
